import styled from 'styled-components';

interface ITheaterProps {
  $theater: boolean;
}

export const Container = styled.div<ITheaterProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding-top: ${({ $theater }) => ($theater ? '1rem' : '2rem')};
  transition: padding-top 0.2s ease;
`;

/**
 * Caixa que define o tamanho do player.
 *
 * A altura vem da proporção 16:9 (`aspect-ratio`). O VideoPlayer usa
 * height: 100%, então sem uma altura proporcional aqui o vídeo saía cortado —
 * uma altura fixa (ex.: 30rem) não acompanha a largura.
 *
 * A largura máxima também é limitada pela altura da viewport, para que em telas
 * baixas o vídeo caiba inteiro: largura = altura_disponível x 16 / 9.
 */
export const PlayerWrapper = styled.div<ITheaterProps>`
  width: 100%;
  aspect-ratio: 16 / 9;
  transition: max-width 0.2s ease;

  max-width: ${({ $theater }) =>
    $theater
      ? 'min(100%, calc((100vh - 11rem) * 16 / 9))'
      : 'min(52rem, calc((100vh - 17rem) * 16 / 9))'};

  @media (max-width: 1224px) {
    max-width: 100%;
  }
`;
